import React, {Component} from 'react';
import ListingsHeaderV2 from '../../MainListing/ListingsHeaderV2';
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  FlatList,
  TextInput,
  Text,
  Dimensions,
  Alert,
  Platform,
  Image,
  SafeAreaView,
} from 'react-native';
import edit_Icon from '../../assets/editIcon.png';
import deleteIcon from '../../assets/delete_icon.png';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import colors from '../../HelperClasses/AppColor';
import networkService from '../../Network/NetworkManager';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import PropTypes from 'prop-types';
import AddVairantTypeValue from './AddVairantTypeValues';
import EmptyListUI from '../../Component/AppEmptyList';
import addIcon from '../../assets/add_icon.png';
import viewIcon from '../../assets/viewIcon.png';
import disableIcon from '../../assets/disableIcon.png';
import {checkUserRoleModule} from '../../HelperClasses/SingletonClass';
import {MODULEKEYS} from '../../Models/Enum';
import AppConstants from '../../Constants/AppConstants';
import {AppToast} from '../../HelperClasses/AppToast';
import {
  addMixpanelEvent,
  MixpanelEvent,
  MixPannelEnum,
} from '../../Models/MixPannelEnum';
import AppConstantsMessage from '../../Constants/AppConstantsMessage';
import SaveButton from '../../Component/SaveButton';
import SecondryButton from '../../Component/SecondryButton';
import {ToastContainer} from 'react-toastify';
import {TranslateEnum} from '../../Models/TranslateEnum';
import Translations from './Translation';
import AddVariantType from './AddVariantType';
import GenerateText from '../../utils/AI/GenerateText';
import {instructions} from '../../Constants/Instructions';
import {RestrictedFeatureEnum} from '../../Models/RestrictedFeatureEnum';
import SubscribePlan from '../../Component/SubscribePlan';
import HelperVideoView from '../../Component/HelperVideoView';
import {ThemeContext} from '../../HelperClasses/ThemeContext';
import {withRouter} from '../../wrappers/withRouter';
import {withLocale} from '../../Localization/LocaleContext';

const APPURL = require('./../../Constants/URLConstants');

const windowWidth = Dimensions.get('window').width;
let fixedWidth = AppConstants.mobileMaxWidth;
let itsMobileView = windowWidth < fixedWidth ? true : false;

class ListingVariantType extends Component {
  static contextType = ThemeContext;
  translate = (key, fallback) => this.props.localeContext?.translate?.(key, fallback) || fallback || key;
  constructor(props) {
    super(props);
    this.state = {
      variantTypeArray: [],
      dataLoad: false,
      isEdit: false,
      selectedVariantID: 0,
      addVariantTypeValueBool: false,
      selectedVariantName: '',
      haveData: false,
      selectedVariantData: {},
      writeP: AppConstants.defaultWrite,
      deleteP: AppConstants.defaultDelete,
      translationBool: false,
      addVariantBool: false,
      selectedData: '',
      showUpgrade: false,
    };
  }
  static propTypes = {
    editBtn: PropTypes.func,
    type: PropTypes.string,
    addListingVariantTypeData: PropTypes.any,
  };
  componentDidMount() {
    addMixpanelEvent(MixpanelEvent.viewVariantType, {
      type: MixPannelEnum.listView,
    });
    this.loadValueTypesApi();
    this.checkModule();
  }
  checkModule = () => {
    checkUserRoleModule(MODULEKEYS.LISTIINGSVARIANTTYPES, res => {
      this.setState({writeP: res[1], deleteP: res[2]});
    });
  };
  //MARK:-  APIS Method 
  loadValueTypesApi = async () => {
    this.setState({dataLoad: false});
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.addVariant,
      'get',
    );
    this.setState({variantTypeArray: []});
    if (responseJson['status'] == true) {
      var vTypeD = responseJson['data']['variant_types'];
      for (let objc of vTypeD) {
        this.state.variantTypeArray.push(objc);
      }
      this.state.haveData =
        this.state.variantTypeArray.length == 0 ? true : false;
    }
    this.setState({dataLoad: true});
  };
  deleteVariantTypeApi = async id => {
    this.setState({dataLoad: false});
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.addVariant + '/' + id,
      'delete',
    );
    this.setState({dataLoad: true});
    if (responseJson['status'] == true) {
      this.mixpanelInfo(true);
      this.loadValueTypesApi();
      this.alertView('delete');
    } else {
      this.mixpanelInfo(false);
    }
  };
  mixpanelInfo(resp) {
    let properties = {success: resp};
    addMixpanelEvent(`${MixpanelEvent.deleteVariantType}`, properties);
  }
  alertView(title) {
    AppToast(title);
  }

  editButtonAction = index => {
    let id_Index = this.state.variantTypeArray.findIndex(x => x.id === index);

    this.setState({
      addVariantBool: true,
      isEdit: true,
      selectedData: this.state.variantTypeArray[id_Index],
    });
  };

  addVariantTypeValueBtnAction = (id, index) => {
    let id_Index = this.state.variantTypeArray.findIndex(x => x.id === id);
    this.setState({
      selectedVariantName: this.state.variantTypeArray[id_Index]['name'],
      selectedVariantID: this.state.variantTypeArray[id_Index]['id'],
      selectedVariantData: this.state.variantTypeArray[id_Index],
      // addVariantTypeValueBool: !this.state.addVariantTypeValueBool,
    });

    let valuesArry = this.state.variantTypeArray[id_Index]['values'] ?? [];
    if (valuesArry.length == 0 && index == 2) {
      AppToast(this.translate('listing_variants.add_value_first', AppConstantsMessage.viewListingVariantTypesMsg));
    } else {
      this.setState({
        addVariantTypeValueBool: !this.state.addVariantTypeValueBool,
        justShowVariants: index == 2 ? true : false,
      });
    }
  };
  deleteVariantAction = index => {
    let msg = this.translate('listing_variants.delete_confirm', 'Do you want to delete this variant type?');
    if (Platform.OS === 'web') {
      const r = window.confirm(msg);
      if (r == true) {
        this.deleteVariantTypeApi(index);
      }
    }
  };
  backBtnAction() {
    this.loadValueTypesApi();
    this.setState({
      addVariantTypeValueBool: false,
      addVariantBool: false,
      justShowVariants: false,
    });
  }
  addVariantTypeBtnAction() {
    this.setState({addVariantBool: !this.state.addVariantBool});
    this.setState({isEdit: false});
  }
  checkRestriction() {
    return (
      AppConstants.restrictedFeatureArray?.includes(
        RestrictedFeatureEnum.variantTypes,
      ) ||
      AppConstants.accessControl?.[AppConstants.plan_name]?.includes(
        RestrictedFeatureEnum.variantTypes,
      )
    );
  }
  /*  UI   */
  tableViewHeader = props => {
    return (
      <FlatList
        data={tableHeaderString}
        horizontal={true}
        renderItem={this.tableHeaderCell}
        extraData={this.state}
        showsVerticalScrollIndicator={false}
        scrollEnabled={false}
      />
    );
  };
  tableHeaderCell = ({item, index}) => {
    const themeColors = this.context?.colors ?? colors;
    const key = item === 'Name' ? 'name' : item === 'Values' ? 'values' : item === 'Status' ? 'status' : item === 'Action' ? 'action' : 'add_value';
    return (
      <View style={styles.tableViewTitleViewStyle}>
        <Text style={[tableStyle.tableViewTitleStyle, {color: themeColors.primaryText}]}>{this.translate(`listing_variants.${key}`, item)}</Text>
      </View>
    );
  };
  columnDataView = props => {
    const themeColors = this.context?.colors ?? colors;
    if (this.state.variantTypeArray.length == 0) {
      if (this.state.haveData) {
        return <EmptyListUI />;
      } else {
        return <View />;
      }
    } else {
      var views = [];
      for (let i = 0; i < this.state.variantTypeArray.length; i++) {
        views.push(
          <FlatList
            data={[
              this.state.variantTypeArray[i]['name'],
              this.state.variantTypeArray[i]['id'],
              this.state.variantTypeArray[i]['active'],
              this.state.variantTypeArray[i]['id'],
              this.state.variantTypeArray[i]['id'],
            ]}
            style={{
              backgroundColor: themeColors.cardBackground,
              borderBottomColor: themeColors.borderColor,
            }}
            horizontal={true}
            renderItem={this.columnCell}
            extraData={this.state}
            showsVerticalScrollIndicator={false}
            scrollEnabled={true}
          />,
        );
      }
      return views;
    }
  };
  columnCell = ({item, index}) => {
    const themeColors = this.context?.colors ?? colors;
    const cellStyle = [
      styles.columnTitleViewStyle,
      {backgroundColor: themeColors.cardBackground, borderBottomColor: themeColors.borderColor},
    ];
    if (index == 2) {
      let val = item ? this.translate('listing_variants.active', 'Active') : this.translate('listing_variants.inactive', 'Inactive');
      return (
        <View style={cellStyle}>
          <Text
            style={[
              item == true
                ? tableStyle.columnActiveBtnStyle
                : tableStyle.columnDeActiveBtnStyle,
              {color: themeColors.secondaryText},
            ]}>
            {val}
          </Text>
        </View>
      );
    } else if (index == 1) {
      let id_Index = this.state.variantTypeArray.findIndex(x => x.id === item);
      let values = this.state.variantTypeArray[id_Index]['values'];
      return (
        <View style={cellStyle}>
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
            <Text style={[tableStyle.columnViewTitleStyle, {color: themeColors.primaryText}]}>{values.length}</Text>
          </View>
        </View>
      );
    } else if (index == 3) {
      return (
        <View style={cellStyle}>
          <View style={{flexDirection: 'row'}}>
            {this.renderEditBtn(item)}
            <View style={{width: 10}} />
            {this.renderDeleteBtn(item)}
          </View>
        </View>
      );
    } else if (index == 4) {
      return (
        <View style={cellStyle}>
          <TouchableOpacity
            disabled={!this.state.writeP}
            onPress={() => this.addVariantTypeValueBtnAction(item)}>
            <Image
              style={tableStyle.iconStyle}
              resizeMode="center"
              source={this.state.writeP ? addIcon : disableIcon}
            />
          </TouchableOpacity>
          <View style={{width: 10}} />
          <TouchableOpacity
            onPress={() => this.addVariantTypeValueBtnAction(item, 2)}>
            <Image
              style={tableStyle.iconStyle}
              resizeMode="center"
              source={viewIcon}
            />
          </TouchableOpacity>
          <View style={{width: 10}} />
          <TouchableOpacity onPress={() => this.props.navigate(`/variant-type/${item}`)}>
            <Text style={{fontSize: 12, color: colors.AppNewGreen, fontWeight: '600'}}>{this.translate('listing_variants.details', 'Details')}</Text>
          </TouchableOpacity>
        </View>
      );
    } else {
      return (
        <View style={cellStyle}>
          <Text style={[tableStyle.columnViewTitleStyle, {color: themeColors.primaryText}]}>{item}</Text>
        </View>
      );
    }
  };
  renderEditBtn = item => {
    return (
      <TouchableOpacity
        disabled={!this.state.writeP}
        onPress={() => this.editButtonAction(item)}>
        <Image
          style={tableStyle.iconStyle}
          resizeMode="center"
          source={this.state.writeP ? edit_Icon : disableIcon}
        />
      </TouchableOpacity>
    );
  };
  renderDeleteBtn = item => {
    return (
      <TouchableOpacity
        disabled={!this.state.deleteP}
        onPress={() => this.deleteVariantAction(item)}>
        <Image
          style={tableStyle.iconStyle}
          resizeMode="center"
          source={this.state.deleteP ? deleteIcon : disableIcon}
        />
      </TouchableOpacity>
    );
  };
  renderTranslateBtnView = () => {
    return (
      <View>
        <SecondryButton
          showBtn={true}
          btnTitle={this.translate('listing_variants.translate', 'Translate')}
          btnAction={() =>
            this.setState({translationBool: !this.state.translationBool})
          }
        />
      </View>
    );
  };

  renderUpgradePlanView() {
    if (!this.state.showUpgrade) return null;
    return <SubscribePlan upgrade featureKey={RestrictedFeatureEnum.variantTypes} contextLabel="Listing variants" onClose={() => this.setState({showUpgrade: false})} />;
  }

  renderHeaderView = () => {
    const themeColors = this.context?.colors ?? colors;
    return (
      <ListingsHeaderV2
        simple={true}
        titleArea={
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
            <Text style={[tableStyle.titleTextStyle, {margin: 0, color: themeColors.primaryText}]}>{this.translate('listing_variants.title', 'Variant Types')}</Text>
            <View style={{marginLeft: 12}}>
              <HelperVideoView
                helperVideoBtnAction={() =>
                  window.open(AppConstants.variantsTypesVideo, '_blank')
                }
              />
            </View>
          </View>
        }
        actionControl={
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
            <this.renderTranslateBtnView />
            <SaveButton
              saveBtn={() => this.addVariantTypeBtnAction()}
              saveBtnTitle={this.translate('listing_variants.add_type', 'Add Variant Type')}
              btnDeActive={this.checkRestriction()}
              showLock={true}
              deActiveBtnAction={() => this.setState({showUpgrade: true})}
            />
          </View>
        }
      />
    );
  };
  render() {
    if (this.state.addVariantTypeValueBool) {
      return (
        <ScrollView style={{flexDirection: 'column'}}>
          <AddVairantTypeValue
            type={this.props.type}
            isEdit={this.state.isEdit}
            variantName={this.state.selectedVariantName}
            variantID={this.state.selectedVariantID}
            variantTypeData={this.state.selectedVariantData}
            justShowVariants={this.state.justShowVariants}
            localeContext={this.props.localeContext}
            backBtnAction={() => this.backBtnAction()}
          />
        </ScrollView>
      );
    } else if (this.state.addVariantBool) {
      return (
        <ScrollView style={{flexDirection: 'column'}}>
          <ToastContainer />
          <AddVariantType
            type={this.props.type}
            isEdit={this.state.isEdit}
            variantTypeData={this.state.selectedData}
            localeContext={this.props.localeContext}
            backBtnAction={() => this.backBtnAction()}
          />
        </ScrollView>
      );
    } else if (this.state.translationBool) {
      return (
        <View style={{flexDirection: 'column'}}>
          <ToastContainer />
          <Translations
            titleString={this.props.type}
            translationTitle={this.translate('listing_variants.title', 'Variant Types')}
            translationRef={TranslateEnum.listingVariant}
            backBtnAction={() => this.setState({translationBool: false})}
          />
        </View>
      );
    } else {
      return (
        <SafeAreaView
          style={[styles.Container, {backgroundColor: (this.context?.colors ?? colors).screenBackground}]}
          className="listing-variant-types-page">
          <View style={{zIndex: 101}}>{this.renderUpgradePlanView()}</View>
          <this.renderHeaderView />
          <View style={[tableStyle.containerMainView, {backgroundColor: (this.context?.colors ?? colors).cardBackground, borderColor: (this.context?.colors ?? colors).borderColor}]}>
            <ToastContainer />
            <ScrollView
              style={[tableStyle.mainScrollViewStyle, {backgroundColor: (this.context?.colors ?? colors).cardBackground}]}
              horizontal={true}>
              <View>
                <View style={[tableStyle.headerListContainer, {backgroundColor: (this.context?.colors ?? colors).tableHeaderBackground}]}>
                  <this.tableViewHeader />
                </View>
                <ScrollView>
                  <this.columnDataView />
                </ScrollView>
              </View>
            </ScrollView>
          </View>
          <Appload enable={this.state.dataLoad} />
        </SafeAreaView>
      );
      //}
    }
  }
}
const divideWidth = 5;
const styles = StyleSheet.create({
  Container: {
    flex: 1,
    backgroundColor: colors.AppLightGreen,
  },
  tableViewTitleViewStyle: {
    padding: 0,
    width: windowWidth < fixedWidth ? 130 : windowWidth / divideWidth,
  },
  columnTitleViewStyle: {
    width: windowWidth < fixedWidth ? 130 : windowWidth / divideWidth,
    borderBottomWidth: 1,
    borderBottomColor: colors.SimonGray,
    padding: 10,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
});

const tableHeaderString = ['Name', 'Values', 'Status', 'Action', 'Add Value'];

export default withRouter(withLocale(ListingVariantType));
